module.exports = __webpack_public_path__ + "img/banner-icon-03.ba96f47f.svg";